import { IWorkflowData } from '~app/shared/interfaces/workflow-data.interface';

export class WorkflowState {
  public readonly data: IWorkflowData;

  constructor(data: IWorkflowData) {
    this.data = data;
  }

  public get preCheckStatus(): number {
    return this.data.precheckStatus;
  }

  public get debarkStatus(): number {
    return this.data.debarkStatus;
  }

  public get medicalStatus(): number {
    return this.data.medicalStatus;
  }
}
